import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsEmployeesGestor = (areaSelectedId, type, ruc) => apiActionCreator({
  'endpoint': `/wts/catalog/employee?area=${areaSelectedId}&type=${type}&ruc=${ruc}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEES_GESTOR,
    ActionTypes.FETCHED_WTS_EMPLOYEES_GESTOR,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEES_GESTOR_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsEmployeesByCharge = (charge) => apiActionCreator({
  'endpoint': `/wts/catalog/employee?cargo=${charge}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEES_BY_CHARGE,
    ActionTypes.FETCHED_WTS_EMPLOYEES_BY_CHARGE,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEES_BY_CHARGE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsEmployeeById = (id) => apiActionCreator({
  'endpoint': `/wts/catalog/employee?id=${id}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_BY_ID,
    ActionTypes.FETCHED_WTS_EMPLOYEE_BY_ID,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_BY_ID_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsEmployeeByEmail = (email) => apiActionCreator({
  'endpoint': `/wts/catalog/employeeEmail?email=${email}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_BY_EMAIL,
    ActionTypes.FETCHED_WTS_EMPLOYEE_BY_EMAIL,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_BY_EMAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsEmployeesEvaluator = (areaSelectedId, type, ruc) => apiActionCreator({
  'endpoint': `/wts/catalog/employee?area=${areaSelectedId}&type=${type}&ruc=${ruc}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEES_EVALUATOR,
    ActionTypes.FETCHED_WTS_EMPLOYEES_EVALUATOR,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEES_EVALUATOR_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateWtsEmployeeStatus = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/employee-status',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_EMPLOYEES_STATUS,
        [
          () => {
            dispatch(getWtsEmployeesGestor(areaSelectedId, '', ''));
            return {'type': ActionTypes.UPDATED_WTS_EMPLOYEES_STATUS};
          },
          MessageActions.addMessageBoxInfo('Asistente modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_EMPLOYEES_STATUS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const changeWtsEmployeeSelected = (employeeSelected) => ({
  'type': ActionTypes.CHANGE_WTS_EMPLOYEE_SELECTED,
  'payload': employeeSelected,
});

export const createWtsEmployee = (payload) => (dispatch, getState) => {
  const {areaSelected} = getState().wtsAreas;
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/catalog/employee',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_EMPLOYEE,
        [
          () => {
            dispatch(getWtsEmployeesGestor(areaSelected.id, '', ''));
            return {'type': ActionTypes.CREATED_WTS_EMPLOYEE};
          },
          MessageActions.addMessageBoxInfo('Empleado creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_EMPLOYEE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': payload,
    })
  );
};

export const updateWtsEmployee = (employeeId, payload) => (dispatch, getState) => {
  const {areaSelected} = getState().wtsAreas;
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/employee?id=${employeeId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_EMPLOYEE,
        [
          () => {
            dispatch(getWtsEmployeesGestor(areaSelected.id, '', ''));
            return {'type': ActionTypes.UPDATED_WTS_EMPLOYEE};
          },
          MessageActions.addMessageBoxInfo('Empleado actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_EMPLOYEE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': payload,
    })
  );
};
